import { cn } from "@/lib/utils";

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("logo", className)}>
      GIT <span className="text-[#E6A91A]">Digest</span>
    </div>
  );
}
